import {
  Component,
  Inject,
  OnInit,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { NgForm, FormControl } from "@angular/forms";
import { UserInfoModel } from "../Models/userinfo.model";
import { Observable, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { Title } from "@angular/platform-browser";
import { DashboardService } from "app/dashboard/dashboard.service";
import { MatDialog } from "@angular/material/dialog";
import { HelplistService } from "app/helplist.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "app/shared/language.service";
import { DOCUMENT, DatePipe } from "@angular/common";
import { CustomthemeComponent } from "../customtheme/customtheme.component";
import { Keepalive } from "@ng-idle/keepalive";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";

import {
  GuidedTourService,
  Orientation,
  GuidedTour,
  ProgressIndicatorLocation,
} from "ngx-guided-tour";
import { CustomerInformation } from "../Models/loggedinuserobj.model";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {

  private destroylogin$: Subject<boolean> = new Subject<boolean>();
  private showsubmit = true;
  private selectedLanguage: any = "en";
  private isOpen: boolean = false;
  private elem;
  private showtheme: boolean;
  private lenghError: boolean;
  private lenghError1: boolean;
  private lenghError2: boolean;
  private verifyClicked = false;
  private verifyPassword: boolean = false;
  private showPassword: boolean;
  private showPassword1: boolean;
  private showPassword2: boolean;
  private showPassword3: boolean;
  private themeComp: any;
  checktour: number = 0;
  private CustomerInformationobj: CustomerInformation = {};
  private expipredatewaring: boolean = false;
  private noofuserwaring: boolean = false;
  private timerdistroy: any;
  @ViewChild("btndashboard", { static: false }) focus_gotodashboard: ElementRef;
  @ViewChild('loginCantainer') private draggableElement: ElementRef;
  userCtrl1: FormControl;
  filtereduserlist: Observable<UserInfoModel[]>;
  private userdetails: any;
  private mobileNo: string;
  private email: string;
  private enterOTP: "";
  private labelChange = true;
  private otpconfirmpassword: string = "";
  private otpnewpassword: string = "";
  private verifypsw: boolean = false;
  private saveresetbtn: boolean = true;
  private userList: any;
  private optbtn: boolean = true;
  private maskMobileNo: string;
  private maskEmail: string;
  private resendbtn = false;
  private conformpsw: boolean;
  private filterRoom: any;
  private selectedIndex: number = 1;
  private timedOut: boolean = false;
  private lastPing?: Date = null;
  private languagetranlate: any = [];
  private languagetranlateTour: any = [];
  private progressIndicatorLocation = ProgressIndicatorLocation.TopOfTourBlock;
  private isProcessing = false;
  public readonly TOUR: GuidedTour = {
    tourId: "TOUR",
    useOrb: false,

    // skipCallback: () => alert("skip clicked"),
    steps: [
      {
        title: "Language Selection",
        selector: "select",
        content: "Click here to change the language of labels",
        // skipStep: false,
        orientation: Orientation.Bottom,
      },
      {
        title: "User Name",
        selector: "input[type='text']",
        content: "Type your username here",
        // skipStep: false,
        orientation: Orientation.Top,
      },
      {
        title: "Password",
        selector: "input[type='password']",
        content: "Type your password here",
        // skipStep: false,
        orientation: Orientation.Bottom,
      },

      {
        title: "Verify Yourself",
        selector: "button",
        content: "Click here to proceed to verification screen",
        // skipStep: false,
        orientation: Orientation.TopLeft,
      },
      {
        title: "Forgot Password",
        selector: "#forgot",
        content: "Click here if you have forgotten password",
        // skipStep: false,
        orientation: Orientation.TopLeft,
      },
    ],
  };

  private readonly VTOUR: GuidedTour = {
    tourId: "VTOUR",
    useOrb: false,

    steps: [
      {
        title: "Change theme",
        selector: "#changetheme",
        content: "Click here to change the application theme",
        orientation: Orientation.Bottom,
      },
      {
        title: "Company",
        selector: "#companyname",
        content: "Select the company here, if applicable",
        orientation: Orientation.TopLeft,
      },
      {
        title: "Billing company",
        selector: "#billingcompany",
        content: "Select the billing company here, if applicable",
        orientation: Orientation.Bottom,
      },
      {
        title: "Branch",
        selector: "#branch",
        content: "Select the branch you need to log in from, if applicable",
        orientation: Orientation.TopLeft,
      },
      {
        title: "Role",
        selector: "#role",
        content: "Select the role you need to log in as, if applicable",
        orientation: Orientation.TopLeft,
      },
      {
        title: "Room no.",
        selector: "#roomno",
        content: "Select the room no. from where you are logging in",
        orientation: Orientation.TopRight,
      },
      {
        title: "Dashboard",
        selector: "#dashboard",
        content: "Click here to proceed to home screen",
        orientation: Orientation.Top,
      },
    ],
  };
  userListbyname: any;
  areaArray: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private dashboardService: DashboardService,
    private helplistservice: HelplistService,
    private title: Title,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private translate: TranslateService,
    private langservice: LanguageService,
    private guidedTourService: GuidedTourService,
    private idle: Idle,
    private keepalive: Keepalive,
    private datePipe: DatePipe,
    @Inject(DOCUMENT) private document: any
  ) {
    this.timedOut = false;
    this.authService.getdefaulttheme();
    //  this.getallusers();

    this.authService.connect();
    // this.langservice.setdefaultlang();

    this.authService.checkThemeStatus = 1;
    this.authService.langshare.pipe(takeUntil(this.destroylogin$)).subscribe((item) => {
      if (item == "2") {
        if (this.authService.languageMaster.length > 0) {
          var checkdata = [];
          this.authService.languageMaster.forEach((item) => {
            checkdata.push(item.shortName);
          });
          translate.addLangs(checkdata);
        } else {
          translate.addLangs(["en", "fr", "hi", "ar", "ru"]);
        }
      }
    });

    this.getchangedlanguage();
    
    this.authService.showspinner =false;
  }

  getchangedlanguage() {
    this.translate
      .get([
        "content1",
        "content2",
        "content3",
        "content4",
        "content5",
        "content6",
        "content7",
        "Title1",
        "Title2",
        "Title3",
        "Title4",
        "Title5",
        "Title6",
        "Title7",
        "TourTitle1",
        "TourTitle2",
        "TourTitle3",
        "TourTitle4",
        "TourTitle5",
        "Tourcontent1",
        "Tourcontent2",
        "Tourcontent3",
        "Tourcontent4",
        "Tourcontent5",
        "loginvalidationMsg.msg1",
        "loginvalidationMsg.msg2",
        "loginvalidationMsg.msg3",
        "loginvalidationMsg.msg4",
        "loginvalidationMsg.msg5",
        "loginvalidationMsg.msg6",
        "loginvalidationMsg.msg7",
        "loginvalidationMsg.msg8",
        "loginvalidationMsg.msg9",
        "loginvalidationMsg.msg10",
        "loginvalidationMsg.msg11",
        "loginvalidationMsg.msg12",
        "loginvalidationMsg.msg13",
        "loginvalidationMsg.msg14",
        "loginvalidationMsg.msg15",
        "Ok",
        "loginMsg",
        "loginErrMsg",
      ]).pipe(takeUntil(this.destroylogin$))
      .subscribe((x) => {
        this.languagetranlate = [];
        this.languagetranlateTour = [];
        this.authService.LoginvalidationMsg = {};
        this.authService.LoginvalidationMsg = x;
        this.languagetranlate = [
          {
            title: x["Title1"],
            selector: "#changetheme",
            content: x["content1"],
            orientation: Orientation.Bottom,
          },
          {
            title: x["Title2"],
            selector: "#companyname",
            content: x["content2"],
            orientation: Orientation.Top,
          },
          {
            title: x["Title3"],
            selector: "#billingcompany",
            content: x["content3"],
            orientation: Orientation.Top,
          },
          {
            title: x["Title4"],
            selector: "#branch",
            content: x["content4"],
            orientation: Orientation.TopLeft,
          },
          {
            title: x["Title5"],
            selector: "#role",
            content: x["content5"],
            orientation: Orientation.TopLeft,
          },
          {
            title: x["Title6"],
            selector: "#roomno",
            content: x["content6"],
            orientation: Orientation.TopRight,
          },
          {
            title: x["Title7"],
            selector: "#dashboard",
            content: x["content7"],
            orientation: Orientation.Top,
          },
        ];
        this.languagetranlateTour = [
          {
            title: x["TourTitle1"],
            selector: "select",
            content: x["Tourcontent1"],
            // skipStep: false,
            orientation: Orientation.Bottom,
          },
          {
            title: x["TourTitle2"],
            selector: "input[type='text']",
            content: x["Tourcontent2"],
            // skipStep: false,
            orientation: Orientation.Top,
          },
          {
            title: x["TourTitle3"],
            selector: "input[type='password']",
            content: x["Tourcontent3"],
            // skipStep: false,
            orientation: Orientation.Bottom,
          },

          {
            title: x["TourTitle4"],
            selector: "button",
            content: x["Tourcontent4"],
            // skipStep: false,
            orientation: Orientation.TopLeft,
          },
          {
            title: x["TourTitle5"],
            selector: "#forgot",
            content: x["Tourcontent5"],
            // skipStep: false,
            orientation: Orientation.TopLeft,
          },
        ];
      });
  }
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  // getallusers() {
  //   this.http.get<any>(this.authService.newbaseUrl + "UserMaster/GetUserAll").subscribe(
  //     data => {
  //       this.userList = data;
  //       this.userfilter();
  //     }
  //   );
  // }
  getuserdetailbyname() {
    this.maskMobileNo = "";
    this.maskEmail = "";
    this.authService.GetUserDetailResetPassword().pipe(takeUntil(this.destroylogin$)).subscribe((data) => {
      this.userdetails = data;

      if (data.pkUserId > 0) {
        this.mobileNo = this.userdetails.mobileNo;
        if (this.mobileNo.length >= 10) {
          this.optbtn = false;
        } else {
          this.optbtn = true;
        }
        this.email = this.userdetails.email;
        if (this.email) {
          let maskemailId = "";
          let arr = this.email.split("@");
          for (let i = 0; i < arr[0].length - 2; i++) {
            maskemailId += "x";
          }
          this.maskEmail =
            this.email.substring(0, 1) + maskemailId + "@" + arr[1];
        }

        if (this.mobileNo) {
          let mask = "";
          for (let i = 0; i < this.mobileNo.length - 4; i++) {
            mask += "x";
          }
          this.maskMobileNo = mask + this.mobileNo.slice(6, 10);
        }
        this.authService.showforgotpassword();
      } else {
        this.authService.openSnackBar(
          this.authService.LoginvalidationMsg["loginvalidationMsg.msg1"],
          this.authService.LoginvalidationMsg["Ok"]
        );
      }
      // this.userfilter();
    });
  }
  userfilter() {
    this.userCtrl1 = new FormControl();
    this.filtereduserlist = this.userCtrl1.valueChanges.pipe(
      startWith(""),
      map((usrls) =>
        usrls ? this.filteruserlist(usrls) : this.userList.slice()
      )
    );
  }
  filteruserlist(value: string) {
    return this.userList.filter(
      (item) => item.userName.toLowerCase().indexOf(value.toLowerCase()) === 0
    );
  }

  // selectUser(event) {
  //
  //   let getUserId = event.option.id;
  //   this.maskMobileNo = '';
  //   this.maskEmail = '';
  //   this.authService.getUserDetails(getUserId).subscribe(data => {
  //     console.log(data);
  //     this.userdetails = data;
  //     this.mobileNo = this.userdetails.mobileNo;
  //     if (this.mobileNo.length >= 10) {
  //       this.optbtn = false;
  //     }else{
  //       this.optbtn = true;
  //     }
  //     this.email = this.userdetails.email;
  //     if (this.email) {
  //       let maskemailId = '';
  //       let arr = this.email.split('@');
  //       for (let i = 0; i < arr[0].length - 2; i++) {
  //         maskemailId += 'x';
  //       }
  //       this.maskEmail = this.email.substring(0, 1) + maskemailId + '@' + arr[1];
  //     }

  //     if (this.mobileNo) {
  //       let mask = '';
  //       for (let i = 0; i < this.mobileNo.length - 4; i++) {
  //         mask += 'x'
  //       }
  //       this.maskMobileNo = mask + this.mobileNo.slice(6, 10);
  //     }
  //   });
  // }

  //onclick OTP toggling
  sendOTP(name) {
    this.enterOTP = "";
    if (this.mobileNo.length >= 10) {
      if (name == "sendOtp") {
        this.labelChange = false;
      }
      this.verifyClicked = true;
      let payload = {
        BranchId: this.userdetails.fkDefaultBranchId,
        SMSType: "PASSWORD RESET",
        Name:this.authService.Loggeduser.username
      };
      this.authService.userMobileOTP(payload).pipe(takeUntil(this.destroylogin$)).subscribe((data) => {
        const formData = new FormData();
        formData.append("Name", this.authService.Loggeduser.username);
        formData.append("EmailType", "PASSWORD RESET");
        formData.append("ToEmail", this.maskEmail);

        this.authService.userEmailOTP(formData).pipe(takeUntil(this.destroylogin$)).subscribe((otpval) => {
          this.authService.openSnackBar(otpval.message, "OK");
        });
        this.startTimer();
        if (name == "sendOtp") {
          if(data.id == -100 || data.statusCode == -100){
            this.authService.openSnackBar(
              this.authService.LoginvalidationMsg["loginvalidationMsg.msg14"],
              this.authService.LoginvalidationMsg["Ok"]
            ); 
          }else if(data.id == -409 || data.statusCode == -409){
            this.authService.openSnackBar(
              this.authService.LoginvalidationMsg["loginvalidationMsg.msg15"],
              this.authService.LoginvalidationMsg["Ok"]
            ); 
          }else{
            this.authService.openSnackBar(
              this.authService.LoginvalidationMsg["loginvalidationMsg.msg2"],
              this.authService.LoginvalidationMsg["Ok"]
            );
          }
         
        } else {
          if(data.id == -100 || data.statusCode == -100){
            this.authService.openSnackBar(
              this.authService.LoginvalidationMsg["loginvalidationMsg.msg14"],
              this.authService.LoginvalidationMsg["Ok"]
            );
          }else if(data.id == -409 || data.statusCode == -409){
            this.authService.openSnackBar(
              this.authService.LoginvalidationMsg["loginvalidationMsg.msg15"],
              this.authService.LoginvalidationMsg["Ok"]
            ); 
          }else{
            this.authService.openSnackBar(
              this.authService.LoginvalidationMsg["loginvalidationMsg.msg3"],
              this.authService.LoginvalidationMsg["Ok"]
            );
          }
         
        }
      });
    } else {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg4"],
        this.authService.LoginvalidationMsg["Ok"]
      );
    }
  }
  timer: any;
  timeLeft: number = 0; // Timer in seconds (2 minutes = 120 seconds)
  startTimer(): void {
    if(this.authService.DynamicLinks?.otpValidityInSecond !=undefined){
      if(this.authService.DynamicLinks?.otpValidityInSecond >0){
        this.timeLeft=this.authService.DynamicLinks?.otpValidityInSecond;
      }else{
        this.timeLeft=120;
      }
    }else{
      this.timeLeft=120;
    }
    
    this.timer = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft <= 0) {
        clearInterval(this.timer);
      
      }
    }, 1000); // Update the countdown every second
  }
  //onclick OTP toggling
  verifyOTP() {
    if (this.enterOTP) {
      this.authService.vrifypwd(this.authService.Loggeduser.username,this.enterOTP).subscribe((item)=>{
       if(item.id >0 && item.statusCode ==1){
        this.verifyClicked = !this.verifyClicked;
        this.verifyPassword = !this.verifyPassword;
        this.resendbtn = true;
        this.authService.captchadata=false;
        this.authService.logincapcha={};
       }else if(item.id == -101){
        this.authService.openSnackBar(
        'OTP is expired.',
          this.authService.LoginvalidationMsg["Ok"]
        );
       }else if(item.id == -10){
        this.authService.openSnackBar(
          this.authService.LoginvalidationMsg["loginvalidationMsg.msg6"],
          this.authService.LoginvalidationMsg["Ok"]
        );
       }else if(item.id == -100){
        this.authService.openSnackBar(
          'OTP verify limit exceed.',
          this.authService.LoginvalidationMsg["Ok"]
        );
       }else if(item.id == -102){
        this.authService.openSnackBar(
          'OTP verify is locked.',
          this.authService.LoginvalidationMsg["Ok"]
        );
       }else{
        this.authService.openSnackBar(
          'password verify unsuccessful',
          this.authService.LoginvalidationMsg["Ok"]
        );
       }
      
      },err=>{
        this.authService.openSnackBar(
          'API Failed',
          this.authService.LoginvalidationMsg["Ok"]
        );
      })
     
    } else {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg5"],
        this.authService.LoginvalidationMsg["Ok"]
      );
    }
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }
  showHidePassword1() {
    this.showPassword1 = !this.showPassword1;
  }
  showHidePassword2() {
    this.showPassword2 = !this.showPassword2;
  }
  showHidePassword3() {
    this.showPassword3 = !this.showPassword3;
  }
  showConformPassword() {
    this.conformpsw = !this.conformpsw;
  }

  switchLang(lang: string) {
    this.selectedLanguage = lang;

    this.langservice.switchLang(lang);
    if (this.authService.languageMaster.length > 0) {
      const cehckid = this.authService.languageMaster.filter(
        (item) => item.shortName == this.selectedLanguage
      );
      this.authService.pklanguageid = cehckid[0]?.pK_LanguageId;

    } else {
      this.authService.pklanguageid = 1;
    }
    this.getchangedlanguage();
   
  }

  ngOnInit() {
    this.authService.logincapcha={};
    this.isProcessing = false;
    this.selectedLanguage = 'en';
    this.authService.users = null;;
    this.authService.FinYears = null;
    this.authService.Roles = null;
    this.authService.Rooms = null;
    this.authService.Branches = null;
    this.authService.Companies = null;
    this.authService.BillingCompanies = null;
    this.authService.webreportConfig = null;
    this.authService.smsConfigdata = null;
    this.checktour = 0;
    this.authService.captchadata=false;
    // this.helplistservice.checkGuideTourNumber = 0;
    this.themeComp = new CustomthemeComponent(
      this.dialog,
      this.authService,
      this.dashboardService,
      this.translate,
      this.langservice
    );
    this.showtheme = false;
    this.elem = document.documentElement;
    this.title.setTitle("Webnetram-Login");
    this.authService.Loggeduser.branchid = 0;
    this.authService.Loggeduser.usertypeid = 0;

    this.authService.Loggeduser = {};
    clearInterval(this.authService.timeInterval);
    this.authService.Loggeduser.username = null;
    this.authService.Loggeduser.password = null;
    this.authService.Loggeduser.sessionInterval = null;
    setTimeout(() => {
      this.focus_gotodashboard.nativeElement.focus();
    }, 500);

    this.lenghError = false;
    this.authService.setThemefontvalues();


    this.authService.langshare.pipe(takeUntil(this.destroylogin$)).subscribe((x: any) => {
      if (x != 0 && x != 2) {
        this.switchLang(x);
      }
    });
    this.authService.getloginDynamicLinks();
    window.onbeforeunload = () => {
      sessionStorage.removeItem('userPhotoLoaded'); 
      //this.authService.Loggedout(1);
      this.ngOnDestroy();
      return false;
    };
  
  }

  blueColor() {
    this.selectedIndex = 1;
    const colorcode = "#1b3465";
    document.documentElement.style.setProperty(
      "--pageButton-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--loginheadbg-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--seticonsbg-colour",
      colorcode
    );
  }
  // orangeColor(){
  //   this.selectedIndex=2;
  //   const colorcode='#F7931E';
  //   document.documentElement.style.setProperty('--pageButton-colour', colorcode);
  //   document.documentElement.style.setProperty('--loginheadbg-colour', colorcode);
  //   document.documentElement.style.setProperty('--seticonsbg-colour', colorcode);
  // }
  cyanColor() {
    this.selectedIndex = 2;
    const colorcode = "#135c65";
    document.documentElement.style.setProperty(
      "--pageButton-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--loginheadbg-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--seticonsbg-colour",
      colorcode
    );
  }
  blackColor() {
    this.selectedIndex = 3;
    const colorcode = "#000000";
    document.documentElement.style.setProperty(
      "--pageButton-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--loginheadbg-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--seticonsbg-colour",
      colorcode
    );
  }
  public startTour(val): void {
    if (val == 0) {
      this.TOUR.steps = [];
      this.TOUR.steps = this.TOUR.steps.concat(this.languagetranlateTour);
      this.guidedTourService.startTour(this.TOUR);
    } else if (val == 1) {
      this.VTOUR.steps = [];
      this.VTOUR.steps = this.VTOUR.steps.concat(this.languagetranlate);
      this.guidedTourService.startTour(this.VTOUR);
    }
    // ;
  }

  public verifyTour(): void {
    // ;
  }

  enablesubmit() {
    if (this.authService.Loggeduser.password?.length > 0) {
      this.showsubmit = false;
    } else {
      this.showsubmit = true;
    }
    if (!this.authService.Loggeduser.username) {
      this.authService.captchadata = false;
      this.authService.logincapcha={};
    } 
  }
  keyDownFunction(event) {
    if (event.keyCode === 13) {
      this.validateuser();
    }
  }

  showfogotPassword() {
    if (
      this.authService.Loggeduser.username != "" &&
      this.authService.Loggeduser.username != null
    ) {
      this.getuserdetailbyname();
      this.verifyPassword = false;
    } else {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg7"],
        this.authService.LoginvalidationMsg["Ok"]
      );
    }
  }

  validateuser() {
    if (this.authService.Loggeduser.username == "") {
      this.authService.Loggeduser.username = null;
    }
    if (this.authService.Loggeduser.password == "") {
      this.authService.Loggeduser.password = null;
    }
    if (
      this.authService.Loggeduser.username == null &&
      this.authService.Loggeduser.password == null
    ) {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg8"],
        this.authService.LoginvalidationMsg["Ok"]
      );
      this.verifyClicked = true;
      return;
    } else if (
      this.authService.Loggeduser.username !== null &&
      this.authService.Loggeduser.password == null
    ) {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg9"],
        this.authService.LoginvalidationMsg["Ok"]
      );
      return;
    } else if (
      this.authService.Loggeduser.username == null &&
      this.authService.Loggeduser.password !== null
    ) {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg7"],
        this.authService.LoginvalidationMsg["Ok"]
      );
      return;
    }
    if (this.authService.Loggeduser.password?.length < 6) {
      this.lenghError = true;
      setInterval(() => {
        this.lenghError = false;
      }, 2000);
    }
    
    if (
      this.authService.Loggeduser.username &&
      this.authService.Loggeduser.password
    ) {
      this.showtheme = true;
      this.chkuser();
      this.cd.detectChanges();
      this.focus_gotodashboard?.nativeElement.focus();
    }
    // this.authService.getcheckSIngal();
  }

  login(comdetailform: NgForm) {
    this.movetodashboard(comdetailform);
  }

  movetodashboard(comdetailform: NgForm) {
    for (let com of this.authService.Companies) {
      if (com.pkCompanyId == comdetailform.value.company) {
        this.authService.Loggeduser.companyname = com.companyName;
        //console.log( this.authService.Loggeduser.companyname );
      }
    }

    //fetching billing company name bcoz its hard to get it directly from html
    for (let billcom of this.authService.BillingCompanies) {
      if (billcom.pkBillingCompanyId == comdetailform.value.billcompany) {
        this.authService.Loggeduser.billingcompanyname = billcom.billingCompany;
        //console.log( this.authService.Loggeduser.billingcompanyname );
      }
    }

    //fetching branch name bcoz its hard to get it directly from html
    for (let branch of this.authService.Branches) {
      if (branch.pkBranchId == this.authService.Loggeduser.branchid) {
        this.authService.Loggeduser.branchname = branch.branchName;
        //console.log( this.authService.Loggeduser.branchname );
      }
    }

    //fetching Role name bcoz its hard to get it directly from html
    for (let role of this.authService.Roles) {

      if (role.roleTypeId == this.authService.Loggeduser.usertypeid) {
        // this.authService.selectedrole = comdetailform.value.usertype;

        this.authService.Loggeduser.role = role.roleType;
        //console.log( this.authService.Loggeduser.role );
      }
    }
    if (this.authService.Roles.length == 0 || this.authService.Loggeduser.role == null || this.authService.Loggeduser.role == undefined) {
      return this.dashboardService.openSnackBar(
        "Please update role in user master",
        this.authService.LoginvalidationMsg["Ok"]
      );
    }
  
    if(this.authService.Roles[0]?.roleType.toLowerCase() === 'doctor'){
      if(this.authService.areaArray.length >0){
      if(!this.authService.LoginsubSpecialityName){
        return this.dashboardService.openSnackBar(
          "Please select speciality in user master.",
          this.authService.LoginvalidationMsg["Ok"]
        );
      }
    }else{
      return this.dashboardService.openSnackBar(
        "Please update the speciality in the user master.",
        this.authService.LoginvalidationMsg["Ok"]
      );
    }
    }
    
    
    this.authService.GetCustomerInformation(0).pipe(takeUntil(this.destroylogin$)).subscribe(
      (x) => {
        this.CustomerInformationobj = {};
        if (x.pK_CustomerId > 0) {
          this.CustomerInformationobj = x;
          if (Date.parse(this.datePipe.transform(this.CustomerInformationobj.eDate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd").toString())) {

            if (x.totalUser >= this.authService.activatedusers) {

              this.updateroom();
              this.helplistservice.fill_help_lists(0);
            } else {
              this.expipredatewaring = false;
              this.noofuserwaring = true;
              this.document.getElementById('CustomerInformationModel').style.display = 'block'
            }
          } else {
            this.expipredatewaring = true;
            this.noofuserwaring = false;
            this.document.getElementById('CustomerInformationModel').style.display = 'block'
          }
        } else {
          this.dashboardService.openSnackBar(
            "Configuration Customer Information Not Found",
            this.authService.LoginvalidationMsg["Ok"]
          );
        }
      },
      (err) => {
        this.dashboardService.openSnackBar(
          "Configuration Customer Information API Failed",
          this.authService.LoginvalidationMsg["Ok"]
        );
      }
    );
  }
  someMethodRoom(event){

   if(event>0){
   const rommname=  this.authService.Rooms.filter(item=>item.pkRoomId==event);
   this.authService.Loggeduser.room=rommname[0].roomNo;
   }
  }
  updateroom() {
    if((this.authService.branchesobject?.loginRoomIdMandatory=='Y')|| (this.authService.Rooms.length >0 && this.authService.Loggeduser.roomid >0)){
    if(this.authService.Rooms.length >0){
      if(this.authService.Loggeduser.roomid >0){
        this.dashboardService.open_loader_Dialog();
        this.authService.updateroom().pipe(takeUntil(this.destroylogin$)).subscribe(
          (data) => this.successroom(data),
          (err) => this.failedroom(err)
        );
      }else{
        this.dashboardService.openSnackBar(
          "Please Select Room No.",
          this.authService.LoginvalidationMsg["Ok"]
        );
      }
     
    }else{
      this.dashboardService.openSnackBar(
        "Please update room no in user master.",
        this.authService.LoginvalidationMsg["Ok"]
      );
     
    }
  }else{
    this.successroom(0);
  }
   
  }
  successroom(data) {
    if (this.authService.Loggeduser.sessionInterval > 0) {
      this.idle.setIdle(this.authService.Loggeduser.sessionInterval * 60 - 10);
      this.idle.setTimeout(
        this.authService.Loggeduser.sessionInterval * 60 - 10
      );
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.idle.onTimeout.subscribe(() => {
        this.timedOut = true;
        this.authService.Loggedout(1);
      });
      this.keepalive.interval(
        this.authService.Loggeduser.sessionInterval * 60 - 10
      );

      this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
      this.reset();
    }

    this.saveLanguage();
    this.saverole();
    this.dialog.closeAll();

    if (
      this.authService.Loggeduser.usertypeid == 6 &&
      this.authService.masterdata.isDashBorad == true
    ) {
      this.draggableElement.nativeElement.remove();
      this.router.navigate(["/layout/doctor-dashboard"], { replaceUrl: true });
    } else {
      this.draggableElement.nativeElement.remove();
     
      this.router.navigate(["/layout/dashboard"], { replaceUrl: true });
    }
  }
  closeCustomerInformationModel() {
    this.expipredatewaring = false;
    this.noofuserwaring = false;
    this.authService.Loggedout(1);
    this.document.getElementById("CustomerInformationModel").style.display =
      "none";
  }
  saverole(){
    let payload={
      "IsActive":true,
      "Ur":this.authService.Loggeduser.usertypeid,
      "BranchId":this.authService.Loggeduser.branchid
    }
    this.authService.Getsaverole(payload).subscribe((x:any)=>{

    })
  }
  saveLanguage() {
    let checkarray = this.authService.customeThemeAray.filter(
      (item) => item.tag == "Language"
    );
    if (checkarray.length > 0) {
      let boj = {
        WebTheme: [
          {
            PK_TranId: checkarray[0].pK_TranId,
            Theme: checkarray[0].theme,
            Fk_UserID: checkarray[0].fk_UserID,
            Tag: "Language",
            Property: "defaultLanguage",
            Value: this.selectedLanguage,
            IsActive: true,
            FK_CreatedById: checkarray[0].fk_UserID,
            CreateDateTime: null,
          },
        ],
      };
      if (this.selectedLanguage != checkarray[0].value) {
        this.authService.insertthemedata(boj).pipe(takeUntil(this.destroylogin$)).subscribe((x: any) => { });
      }
    } else {
      let boj = {
        WebTheme: [
          {
            PK_TranId: 0,
            Theme: "Default",
            Fk_UserID: this.authService.Loggeduser.userid,
            Tag: "Language",
            Property: "defaultLanguage",
            Value: this.selectedLanguage,
            IsActive: true,
            FK_CreatedById: this.authService.Loggeduser.userid,
            CreateDateTime: null,
          },
        ],
      };
      if (this.selectedLanguage != undefined) {
        this.authService.insertthemedata(boj).pipe(takeUntil(this.destroylogin$)).subscribe((x: any) => { });
      }
    }
  }

  chkusertype(event) {
    this.authService.selectedrole = event.target.value;
   
  }
  chkSpecility(event) {
    this.authService.LoginsubSpecialityName = event.target.value;
  }

  failedroom(err) {
    this.dialog.closeAll();
    this.dashboardService.openSnackBar(
      this.authService.LoginvalidationMsg["loginvalidationMsg.msg10"],
      this.authService.LoginvalidationMsg["Ok"]
    );
  }

  chkuser() {
    this.checktour = 1;
    //  if(!JSON.parse(localStorage.getItem('token'))){
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    this.authService.login();
    setTimeout(() => {
      this.isProcessing = false;

    }, 1000);

    // }else{
    //   this.authService.openSnackBar(
    //     "User already logged in",
    //     this.authService.LoginvalidationMsg["Ok"]
    //   );
    // }

  }

  YesSameUser() {
    this.authService.SameUserLogin = false;
    this.authService.showloginbox = false;
    this.authService.showcompanybox = true;
    this.authService.Loggedout(0);

    this.dashboardService.openSnackBar(
      this.authService.LoginvalidationMsg["loginMsg"],
      this.authService.LoginvalidationMsg["Ok"]
    );
  }
  NoSameUser() {
    this.authService.gobacklogin();
    this.authService.SameUserLogin = false;
  
  }

  custometheme() {
    const dialogRef = this.dialog.open(CustomthemeComponent, {
      panelClass: "full-width-dialog",
      height: "auto",
      width: "80%",
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroylogin$)).subscribe((result) => { });
  }

  onfindoldPassword(event) {
    var Oldpassword = event;
    if (this.authService.Loggeduser.password != Oldpassword) {
      this.lenghError1 = true;
      this.timerdistroy = setInterval(() => {
        this.lenghError1 = false;
      }, 2000);
    }

  }
  onNewPasswordFiled(event) {
    var Oldpassword = event;
    if (this.authService.Loggeduser.password != Oldpassword.length) {
      this.lenghError = true;
      setInterval(() => {
        this.lenghError = false;
      }, 2000);
    }
  }

  // changepassword() {
  //   if (this.authService.newpassword.length < 6) {
  //     this.lenghError = true;
  //     setInterval(() => {
  //       this.lenghError = false;
  //     }, 2000);
  //   } else if (
  //     this.authService.confirmpassword != this.authService.newpassword
  //   ) {
  //     this.lenghError2 = true;
  //     setInterval(() => {
  //       this.lenghError2 = false;
  //     }, 2000);
  //   }

  //   this.authService.changepasswordcheck(this.enterOTP);
  // }

  showpassword() {
    this.authService.showpassword();
  }

  gotologin() {
    this.authService.gotologin();
  }

  backtologin() {
    this.authService.gobacklogin();
    setTimeout(() => {
      this.focus_gotodashboard.nativeElement.focus();

    }, 0);
    this.checktour = 0;
    this.otpnewpassword = "";
    this.otpconfirmpassword = "";
    this.enterOTP = "";
    this.labelChange = true;
    this.resendbtn = false;
    this.authService.captchadata=false;
    this.authService.logincapcha={};
  }
  verifyotp() {
    this.authService.verifyotp();
  }

  toggleShow() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  saveResetPassword() {
    if (this.otpnewpassword.length < 6) {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg11"],
        this.authService.LoginvalidationMsg["Ok"]
      );
      return;
    }

    if (this.otpnewpassword !== this.otpconfirmpassword) {
      this.authService.openSnackBar(
        this.authService.LoginvalidationMsg["loginvalidationMsg.msg12"],
        this.authService.LoginvalidationMsg["Ok"]
      );
      return;
    }
    let payload={
      UserName:this.authService.Loggeduser.username,
      OTP:this.enterOTP,
      NewPassword:this.otpnewpassword
     }
    this.authService
      .changepassword(payload).pipe(takeUntil(this.destroylogin$))
      .subscribe((data) => {
        if (data == 200)
          this.authService.openSnackBar(
            this.authService.LoginvalidationMsg["loginvalidationMsg.msg13"],
            this.authService.LoginvalidationMsg["Ok"]
          );
        this.authService.showforgotpasswordbox = false;
        this.authService.showloginbox = true;
      },err=>{
         if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
      });
  }

  enableResetSave() {
    if (
      this.otpnewpassword?.length > 0 &&
      this.otpconfirmpassword?.length > 0
    ) {
      this.saveresetbtn = false;
    } else {
      this.saveresetbtn = true;
    }
  }

  rememberMe(event) {
    this.authService.rememberme = event.checked;
    if (!this.authService.rememberme) {
      // localStorage.clear();
      localStorage.removeItem("userName");
      localStorage.removeItem("password");
    }
  }

  SlectBranchdata(event) {
    this.authService.branchesobject={};
    this.authService.getsmsConfigAPI(this.authService.Loggeduser.branchid);
    const checkbranchobj = this.authService.Branches.filter(item=>item.pkBranchId ==this.authService.Loggeduser.branchid);
    if(checkbranchobj.length >0){
      this.authService.branchesobject=checkbranchobj[0];
    }
    this.authService.getrooms();
  }
 
  ngOnDestroy() {
    clearInterval(this.timerdistroy);
    this.destroylogin$.next(true);
    this.destroylogin$.unsubscribe();
    this.isProcessing = null;
    this.timer=null;
    this.timeLeft =null;
    this.authService.captchadata=null;
    this.authService.logincapcha=null;
    this.authService.themenApiunsub.unsubscribe();
  }
}
